/**
 * Workflow stages (design 31a) and the one status palette: every status glyph,
 * calendar bar and Gantt bar takes its colour from here.
 *
 * - `backlog`  dashed ring
 * - `planned`  empty ring
 * - `active`   half-filled ring
 * - `review`   three-quarter ring (the later half of the active stage)
 * - `done`     filled green check
 * - `cancelled` filled red cross
 */
export type Stage = 'backlog' | 'planned' | 'active' | 'review' | 'done' | 'cancelled'

// 31a's colours, with the original red for Cancelled and a darker stone for Planned,
// so all six stay distinct when a bar has only colour to go on.
export const STAGE_COLOR: Record<Stage, string> = {
  backlog: '#a8a29a',
  planned: '#78716c',
  active: '#eab308',
  review: '#8b5cf6',
  done: '#22c55e',
  cancelled: '#ef4444',
}

/**
 * Map a progress type to its stage. Active (IP) statuses split in two: the first half
 * of the stage reads as "working" (half ring), the later half as "review" (¾ ring), so
 * In Progress / Pending Test and In Review / Ready to Merge look different without
 * matching on names.
 */
export function stageForProgressType(
  progressType: string | null | undefined,
  indexInStage = 0,
  stageSize = 1,
): Stage {
  switch (progressType?.toUpperCase()) {
    case 'BL':
      return 'backlog'
    case 'PL':
      return 'planned'
    case 'IP':
      return indexInStage < Math.ceil(stageSize / 2) ? 'active' : 'review'
    case 'CD':
      return 'done'
    case 'CL':
      return 'cancelled'
    default:
      return 'backlog'
  }
}
